<!-- <app-spinner [show]="isLoading.rooms || isLoading.revenue" [size]="150"> </app-spinner> -->
<div style="margin: 10px; margin-bottom: 130px;">
  <div *ngIf="!isMobileView">
    <mat-tab-group (selectedIndexChange)="tabChange($event)" [(selectedIndex)]="selectedTab"
      (selectedTabChange)="onTabChange($event)">
      <mat-tab label="Pending Requests" style="color: white;"
        [ngClass]="{'clsWrapping': !isMobileView, 'clsWrappingMobile': isMobileView}">
        <div *ngIf="request">
          <!-- <app-owners-portal></app-owners-portal> -->
          <app-interested-host-approval></app-interested-host-approval>
        </div>

      </mat-tab>
      <!-- <mat-tab label="FFL Images" style="color: white;"
        [ngClass]="{'clsWrapping': !isMobileView, 'clsWrappingMobile': isMobileView}">
        <div *ngIf="fflImages">
          <app-ffl-images></app-ffl-images>
        </div>
      </mat-tab> -->
      <mat-tab label="Webinar Queue" style="color: white;"
        [ngClass]="{'clsWrapping': !isMobileView, 'clsWrappingMobile': isMobileView}">
        <div *ngIf="webinarQueue && ownerRoomsList !== undefined && ownerRoomsList.length > 0">
          <app-my-webinar-queue [hostRoom]="ownerRoomsList" [isOwnerPortal]="true" (EditWebinar)="EditWebinar($event)"></app-my-webinar-queue>
        </div>
      </mat-tab>
      <mat-tab label="Revenue Details">
        <div class="row" style="width: 99%;" [formGroup]="RevenueForm">
          <div class="col-md-3 col-sm-12 col-lg-3">
            <mat-form-field>
              <mat-label>Select Date From</mat-label>
              <input matInput [matDatepicker]="picker" formControlName="StartDate" (click)="picker.open()" readonly>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-md-3 col-sm-12 col-lg-3">
            <mat-form-field>
              <mat-label>Select Date To</mat-label>
              <input matInput [matDatepicker]="picker2" [min]="minDate" formControlName="EndDate"
                (click)="picker2.open()" readonly>
              <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-md-3 col-sm-12 col-lg-3">
            <mat-form-field>
              <mat-label>Select Room</mat-label>
              <mat-select formControlName="RoomId">
                <mat-option *ngFor="let room of roomsList" value="{{room.roomId}}">{{room.roomName}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-3 col-sm-12 col-lg-3">
            <button (click)="getRoomWiseRevenueBetweenDates()" class="clsBtn"
              style="margin-top: 10px; margin-bottom: 5px;" [disabled]="!RevenueForm.valid">Search </button> &nbsp;
            <button color="accent" class="paymentButton" style="background-color: rgb(67, 115, 206);"
              *ngIf="roomWiseRevenue !== undefined && roomWiseRevenue !== null" (click)="onExportToExcel()">Export To
              Excel</button>
          </div>
        </div>


        <span *ngIf="roomWiseRevenue !== undefined && roomWiseRevenue === null" style="color: red;">
          **Nil Revenue details found for selected period and "{{
          selectedRoomForValue(this.RevenueForm.controls.RoomId.value) }}".
        </span>
        <div *ngIf="roomWiseRevenue !== undefined && roomWiseRevenue !== null" class="accordion" id="revenueAccordion">
          <div class="accordion-item" style="background-color: rgb(223, 179, 121);">
            <h2 class="accordion-header" id="revenueHeader">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#revenueCollapse" aria-expanded="false" aria-controls="revenueCollapse">
                <div>
                  <strong>Total Revenue :</strong> {{ checkDecimalValue(roomWiseRevenue.revenue) }}$
                  <br>
                  <small>Total Purchases : {{ roomWiseRevenue.purchaseHistory.length }}</small>
                </div>
              </button>
            </h2>

            <div id="revenueCollapse" class="accordion-collapse collapse" aria-labelledby="revenueHeader"
              data-bs-parent="#revenueAccordion">
              <div class="accordion-body">
                <span style="color: rgb(52, 93, 29); font-family: Arial, Helvetica, sans-serif;">
                  Data Found Date From : <b>{{ roomWiseRevenue.dateFrom | date: 'dd MMM yyy' }}</b>
                  To <b>{{ roomWiseRevenue.dateTo | date: 'dd MMM yyy' }}</b>
                </span>

                <!-- Proper Bootstrap grid layout -->
                <div class="container-fluid mt-3 mt-3">
                  <div class="row g-3 px-2">
                    <div class="col-md-6 mb-3" *ngFor="let history of roomWiseRevenue.purchaseHistory;">
                      <div class="card shadow-sm p-3" style="background-color: #fff;">
                        <div class="row">
                          <div class="col-12">
                            <div class="row mb-2">
                              <div class="col-12 col-md-6">
                                TransactionId : <span class="contentCls">{{ history?.transactionId }}</span>
                              </div>
                              <div class="col-12 col-md-6">
                                Price : <span class="contentCls">${{ checkDecimalValue(history?.price) }}</span>
                              </div>
                            </div>
                            <div class="row mb-2">
                              <div class="col-12 col-md-6">
                                OrderId : <span class="contentCls">{{ history?.orderId }}</span>
                              </div>
                              <div class="col-12 col-md-6">
                                Seats : <span class="contentCls">{{ history?.totalSeats }}</span>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12">
                                Room Name : <span class="contentCls">{{ history?.roomName }}</span>
                              </div>
                            </div>
                          </div> <!-- col-12 -->
                        </div> <!-- row -->
                      </div> <!-- card -->
                    </div> <!-- col-md-6 -->
                  </div> <!-- row -->
                </div> <!-- container -->

              </div> <!-- accordion-body -->
            </div> <!-- collapse -->
          </div> <!-- accordion-item -->
        </div> <!-- accordion -->

      </mat-tab>

      <mat-tab label="Lucky Bucks">
        <div *ngIf="luckyBucks" style="width: 99%;">
          <app-add-lucky-bucks></app-add-lucky-bucks>
        </div>
      </mat-tab>

      <mat-tab label="Platform Charges">
        <div class="platform-charges-page">
          <div class="empty-state" *ngIf="allPlatformCharges?.length === 0">
            <mat-icon>percent</mat-icon>
            <h3>No platform charges configured</h3>
            <p>Platform charge rates for webinar rooms will appear here.</p>
          </div>
          <div class="charges-grid" *ngIf="allPlatformCharges?.length > 0">
            <div class="charge-card" *ngFor="let charge of allPlatformCharges">
              <div class="charge-header">
                <h3 class="charge-room">{{ charge?.webinarRoom?.roomName }}</h3>
                <div class="charge-header-actions">
                  <span class="charge-badge">{{ charge?.platformCharge?.percentage | number:'1.2-2' }}%</span>
                  <button
                    mat-icon-button
                    type="button"
                    class="charge-edit-btn"
                    (click)="onUpdatePlatformCharge(charge)"
                    matTooltip="Update platform charge"
                    aria-label="Update platform charge">
                    <mat-icon>edit</mat-icon>
                  </button>
                </div>
              </div>
              <div class="charge-body">
                <div class="info-item">
                  <span class="info-label">Host</span>
                  <span class="info-value">{{ charge?.user?.firstName }} {{ charge?.user?.lastName }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">Platform charge</span>
                  <span class="info-value charge-rate">{{ charge?.platformCharge?.percentage | number:'1.2-2' }}%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Pending Webinar Settlement">
        <app-webinar-settlement *ngIf="isShowSettlement"></app-webinar-settlement>
      </mat-tab>

      <mat-tab label="Completed Webinar Settlement">
        <app-completed-webinar-settlement *ngIf="isShowCompletedSettlement"></app-completed-webinar-settlement>
      </mat-tab>
    </mat-tab-group>
  </div>


  <div *ngIf="isMobileView">
    <mat-form-field appearance="outline">
      <mat-label>Select Your Option</mat-label>
      <mat-select [(ngModel)]="selectedOptionToViewForMobile"
        (selectionChange)="onChangeHostMobielViewOption($event.value)">
        <mat-option value="PendingRequests">Pending Requests</mat-option>
        <!-- <mat-option value="FFLImages">FFL Images</mat-option> -->
        <mat-option value="MyWebinarQueue">Webinar Queue</mat-option>
        <mat-option value="RevenueDetails">Revenue Details</mat-option>
        <mat-option value="LuckyBucks">Lucky Bucks</mat-option>
        <mat-option value="PlatformCharges">Platform Charges</mat-option>
        <mat-option value="PendingWebinarSettlement">Pending Webinar Settlement</mat-option>
        <mat-option value="CompletedWebinarSettlement">Completed Webinar Settlement</mat-option>
      </mat-select>
    </mat-form-field>

    <div *ngIf="selectedOptionToViewForMobile === 'PendingRequests'">
      <app-interested-host-approval></app-interested-host-approval>
    </div>

    <!-- <div *ngIf="selectedOptionToViewForMobile === 'FFLImages'">
      <app-ffl-images></app-ffl-images>
    </div> -->

    <div *ngIf="selectedOptionToViewForMobile === 'MyWebinarQueue' && ownerRoomsList !== undefined && ownerRoomsList.length > 0">
      <app-my-webinar-queue [hostRoom]="ownerRoomsList" [isOwnerPortal]="true" (EditWebinar)="EditWebinar($event)"></app-my-webinar-queue>
    </div>

    <div *ngIf="selectedOptionToViewForMobile === 'RevenueDetails'">
      <div class="row" style="width: 99%;" [formGroup]="RevenueForm">
        <div class="col-md-3 col-sm-12 col-lg-3">
          <mat-form-field>
            <mat-label>Select Date From</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="StartDate" (click)="picker.open()" readonly>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-md-3 col-sm-12 col-lg-3">
          <mat-form-field>
            <mat-label>Select Date To</mat-label>
            <input matInput [matDatepicker]="picker2" [min]="minDate" formControlName="EndDate" (click)="picker2.open()"
              readonly>
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-md-3 col-sm-12 col-lg-3">
          <mat-form-field>
            <mat-label>Select Room</mat-label>
            <mat-select formControlName="RoomId">
              <mat-option *ngFor="let room of roomsList" value="{{room.roomId}}">{{room.roomName}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-3 col-sm-12 col-lg-3">
          <button (click)="getRoomWiseRevenueBetweenDates()" class="clsBtn"
            style="margin-top: 10px; margin-bottom: 5px;" [disabled]="!RevenueForm.valid">Search </button> &nbsp;
          <button color="accent" class="paymentButton" style="background-color: rgb(67, 115, 206);"
            *ngIf="roomWiseRevenue !== undefined && roomWiseRevenue !== null" (click)="onExportToExcel()">Export To
            Excel</button>
        </div>
      </div>
      <span *ngIf="roomWiseRevenue !== undefined && roomWiseRevenue === null" style="color: red;">
        **Nil Revenus details found for selected period and "{{
        selectedRoomForValue(this.RevenueForm.controls.RoomId.value) }}".
      </span>
      <mat-accordion class="example-headers-align" *ngIf="roomWiseRevenue !== undefined && roomWiseRevenue !== null">
        <mat-expansion-panel style="background-color: rgb(223, 179, 121);">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Total Revenue : {{checkDecimalValue(roomWiseRevenue.revenue)}}$
            </mat-panel-title>
            <mat-panel-description>
              Total Purchases : {{roomWiseRevenue.purchaseHistory.length}}
            </mat-panel-description>
          </mat-expansion-panel-header>
          <span style="color: rgb(52, 93, 29);">
            Data Found Date From : <b>{{roomWiseRevenue.dateFrom | date: 'dd MMM yyy'}}</b> To :
            <b>{{roomWiseRevenue.dateTo | date: 'dd MMM yyy'}}</b>
          </span>
          <div class="grid-container">
            <div class="grid-item" *ngFor="let history of roomWiseRevenue.purchaseHistory;">
              <div class="matCard mat-elevation-z4">
                <div class="row">
                  <div class="col-sm-12 col-md-12 col-lg-12">
                    <div class="row">
                      <div class="col-sm-12 col-md-6 col-lg-6">
                        TransactionId : <span class="contentCls"> {{history?.transactionId}}</span>
                      </div>
                      <div class="col-sm-12 col-md-6 col-lg-6">
                        Price : <span class="contentCls"> ${{checkDecimalValue(history?.price)}} </span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12 col-md-6 col-lg-6">
                        OrderId : <span class="contentCls"> {{history?.orderId}}</span>
                      </div>
                      <div class="col-sm-12 col-md-6 col-lg-6">
                        Seats : <span class="contentCls"> {{history?.totalSeats}}</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        Room Name : <span class="contentCls"> {{history?.roomName}}</span>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <div *ngIf="selectedOptionToViewForMobile === 'PlatformCharges'">
      <div class="platform-charges-page">
        <div class="empty-state" *ngIf="allPlatformCharges?.length === 0">
          <mat-icon>percent</mat-icon>
          <h3>No platform charges configured</h3>
          <p>Platform charge rates for webinar rooms will appear here.</p>
        </div>
        <div class="charges-grid" *ngIf="allPlatformCharges?.length > 0">
          <div class="charge-card" *ngFor="let charge of allPlatformCharges">
            <div class="charge-header">
              <h3 class="charge-room">{{ charge?.webinarRoom?.roomName }}</h3>
              <div class="charge-header-actions">
                <span class="charge-badge">{{ charge?.platformCharge?.percentage | number:'1.2-2' }}%</span>
                <button
                  mat-icon-button
                  type="button"
                  class="charge-edit-btn"
                  (click)="onUpdatePlatformCharge(charge)"
                  matTooltip="Update platform charge"
                  aria-label="Update platform charge">
                  <mat-icon>edit</mat-icon>
                </button>
              </div>
            </div>
            <div class="charge-body">
              <div class="info-item">
                <span class="info-label">Host</span>
                <span class="info-value">{{ charge?.user?.firstName }} {{ charge?.user?.lastName }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Platform charge</span>
                <span class="info-value charge-rate">{{ charge?.platformCharge?.percentage | number:'1.2-2' }}%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="selectedOptionToViewForMobile === 'LuckyBucks'">
      <div *ngIf="luckyBucks" style="width: 99%;">
        <app-add-lucky-bucks></app-add-lucky-bucks>
      </div>
    </div>

    <div *ngIf="selectedOptionToViewForMobile === 'PendingWebinarSettlement'">
      <app-webinar-settlement></app-webinar-settlement>
    </div>

    <div *ngIf="selectedOptionToViewForMobile === 'CompletedWebinarSettlement'">
      <app-completed-webinar-settlement></app-completed-webinar-settlement>
    </div>
  </div>

</div>